import type { ReactNode } from 'react'
import { useIsUnionTier } from '../../hooks/useIsUnionTier'

/**
 * Renders `children` only on a Union-tier instance; otherwise `fallback` (default null).
 * The one idiom for union-only chrome inside campaign-visible surfaces.
 */
export function UnionOnly({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  return <>{useIsUnionTier() ? children : fallback}</>
}
